var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('table-list', { ref: "dco-table", attrs: { "list": _vm.list, "columnConfig": _vm.filterColumnConfig, "tableConfig": _vm.tableConfig } }, [_vm._t("action-cell", null, { "slot": "action-cell" })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };